module.exports = __webpack_public_path__ + "6fd260792e4bea6beaa32123ed440c42.svg";